"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFile = uploadFile;
exports.getPlayerFromId = exports.checkForFile = void 0;

var _constants = require("rich-text-lib/api/constants");

var base64ToBlob = function base64ToBlob(base64Str, mimeType) {
  var str = '';

  try {
    str = atob(base64Str);
  } catch (e) {
    return new Blob([]);
  }

  var arr = new Uint8Array(str.length);

  for (var i = 0; i < arr.length; i++) {
    arr[i] = str.charCodeAt(i);
  }

  return new Blob([arr], {
    type: mimeType
  });
};

function uploadFile(fileObj, progress, apiClient) {
  var file = fileObj.file,
      base64 = fileObj.base64;
  var formData = new FormData();

  if (file.size) {
    formData.append('file', file);
  } else {
    formData.append('file', base64ToBlob(base64, file.type), file.name);
  }

  return apiClient.post('filemanager/api/v2/files', {
    timeout: 0,
    headers: {
      'content-type': false
    },
    data: formData,
    withXhr: function withXhr(xhr) {
      xhr.upload.addEventListener('progress', progress, false);
    }
  });
}

var checkForFile = function checkForFile(fullUrl, apiClient) {
  return apiClient.get(_constants.ApiMap.FILE_INFO.getUrl(fullUrl));
};

exports.checkForFile = checkForFile;

var getPlayerFromId = function getPlayerFromId(playerId, apiClient) {
  return apiClient.get(_constants.ApiMap.VIDEO_PLAYER.getUrl(playerId));
};

exports.getPlayerFromId = getPlayerFromId;